import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { getChildrenToRender } from './utils';
import video from '../assets/videos/ad8ce0ec6efbce859730eb0598a585ed.mp4';
class Content13 extends React.PureComponent {
  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    return (
      <div className='content13'>
        <OverPack {...props} {...dataSource.OverPack}>
          <QueueAnim
            type="bottom"
            leaveReverse
            key="page"
            delay={[0, 100]}
            {...dataSource.titleWrapper}
          >
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </QueueAnim>
        </OverPack>
        <video autoPlay muted loop>
          <source src={video} type="video/mp4" />
        </video>
      </div>
    );
  }
}

export default Content13;
